<template>
  <div id="app">
    <Slide :closeOnNavigation="true" >
     <a href="#">
      <span><router-link to="/">Do Re Mi Fa</router-link></span>
     </a>
     <a>
      <span><router-link to="/doremi">Do Re Mi</router-link></span>
     </a>
     <a>
      <span><router-link to="/pentatonicscale">Pentatonic Scale</router-link></span>
     </a>
     <a>
      <span><router-link to="/diatonicscale">Diatonic Scale</router-link></span>
     </a>
    </Slide>
    <b-container id="container">
      <router-view/>
    </b-container>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { Slide } from 'vue-burger-menu'

export default {
  name: 'Scale',
  components: {
    Slide
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height:100vh;
  width:100%;
  background:url('/img/nature.jpg');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center top;
}

#nav {
  padding: 30px;

  a {
    font-weight: normal;
    color:white;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

#container {
  margin-top:70px;
}
</style>
